jQuery_T4NT(document).ready(function ($) {
  /**
   *  Variant selection changed
   *  data-variant-toggle="{{ variant.id }}"
   */
  $(document).on("variant:changed", function (evt) {
    // console.log( evt.currentVariant );
    // $('[data-variant-toggle]').hide(0);
    // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
  });
  //.replace(/,/g, '');
  //div.t4s-product-price > font > font
  // var removeComma = (selector) => {
  //   document.querySelectorAll(selector).forEach((priceTag) => {
  //     priceTag.innerHTML = priceTag.textContent.replace(/,/g, "");
  //   });
  // };
  // ["div.t4s-product-price > font > font", "div.t4s-product-price"].forEach(
  //   (selector) => removeComma(selector)
  // );
});
// document.addEventListener("DOMContentLoaded", function () {
//     function formatPrices() {
//         document.querySelectorAll(".t4s-form__product .t4s-product-price").forEach(function (priceElement) {
//             let priceText = priceElement.textContent.trim();
//             let formattedPrice = priceText.replace(",", " "); // Byter ut komma mot mellanslag
//             if (priceText !== formattedPrice) {
//                 priceElement.textContent = formattedPrice;
//             }
//         });
//     }

//     // Kör direkt vid sidladdning
//     formatPrices();

//     // Observera ändringar i DOM:en (t.ex. AJAX-laddning)
//     let observer = new MutationObserver(function (mutations) {
//         mutations.forEach(function (mutation) {
//             if (mutation.type === "childList" || mutation.type === "subtree") {
//                 formatPrices();
//             }
//         });
//     });

//     // Övervaka body för ändringar i hela sidan
//     observer.observe(document.body, { childList: true, subtree: true });
// });
